import { render, staticRenderFns } from "./Pay_incorrect.vue?vue&type=template&id=2d78202b&scoped=true&"
import script from "./Pay_incorrect.vue?vue&type=script&lang=js&"
export * from "./Pay_incorrect.vue?vue&type=script&lang=js&"
import style0 from "./Pay_incorrect.vue?vue&type=style&index=0&id=2d78202b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d78202b",
  null
  
)

export default component.exports